import React, { useContext, useState, useEffect } from "react"
import Context from "../utils/Context"
import { sendMissionToRobot, cancelActions } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faCog } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../components/ShowMessage"


export default function Missions() {

  const context = useContext(Context)
  const [showWarning, setShowWarning] = useState(false)
  const [showCountdown, setShowCountdown] = useState(false)
  const [countdown, setCountdown] = useState(10)
  const [timer, setTimer] = useState(null)


  const importPoints = () => {

    context.actions.setKonvaPoints([{
      "counter": "pn-3",
      "point": {
        "x": 2.3077112466669716,
        "y": 0.6709100509141863,
        "z": 2
      },
      "name": ["Pick"]
    },
    {
      "counter": "pn-4",
      "point": {
        "x": 1.057417546442558,
        "y": -0.060569367871182445,
        "z": 2
      },
      "name": ["DPick", "Dpick"]
    },
    {
      "counter": "pn-7",
      "point": {
        "x": 0.5606061267343542,
        "y": 1.0811323500245542,
        "z": 2
      },
      "name": ["PPick"]
    },
    {
      "counter": "pn-11",
      "point": {
        "x": 0.07504925744694613,
        "y": 5.526078153597773,
        "z": 2
      },
      "name": ["Place"]
    },
    {
      "counter": "pn-15",
      "point": {
        "x": -1.102106414793322,
        "y": 5.041261410852915,
        "z": 2
      },
      "name": ["PPlace"]
    },
    {
      "counter": "pn-17",
      "point": {
        "x": -2.3718285652743156,
        "y": 8.400504799562661,
        "z": 2
      },
      "name": ["C1"]
    }])

    console.log(" +-+-+ ", context.konvaPoints)
  }


  // start task
  const startTask = (mission) => {
    if (mission) {
      sendMissionToRobot({ actions: mission.actions, id: mission.name, name: mission.name }, context.selectedRobot.ROS)
      console.log('publishing mission: ', { actions: mission.actions, id: mission.name, name: mission.name })
      context.actions.setMessage({ message: "Send Mission", type: "success" })
    }
  }

  // execute a mission
  const execMission = (missionName) => {
    const mission = context.availableMissions.find(m => m.name === missionName)
    const hasUV = mission?.actions?.find(action => action.name === "desinfect-uv" || action.name === "desinfect-all")


    startTask(mission)

  }

  const stopMission = () => {
    if (context.selectedRobot.ROS === 'ROS2') {
      cancelActions({ stopall: true }, context.selectedRobot.ROS)
    } else {
      cancelActions({ stopAll: true }, context.selectedRobot.ROS)
    }
    context.actions.setCurrentTask(null)
    context.actions.setMessage({ message: "Mission Stopped!", type: "success" })
  }


  // start countdown
  const startCountdown = () => {
    setShowCountdown(true)

    setTimer(
      setInterval(() => {
        setCountdown(c => c - 1)
      }, 1000)
    )
  }

  // end of countdown
  useEffect(() => {
    if (countdown === 0) {
      clearInterval(timer)
      setTimer(null)
      setShowCountdown(false)
      setCountdown(10)
      startTask(context.currentMission)
      setShowWarning(false)
    }
  }, [countdown, context.currentMission, timer])

  return (
    <div>
      <button
        onClick={() => context.actions.setModalState({ ...context.modalState, missions: true })}
        className="button is-success mb-5 mr-3"
        styles={{ marginRight: "1rem" }}
      >
        <FontAwesomeIcon icon={faPlus} className="is-small mr-1" />
        Manage Missions
      </button>

      <button
        onClick={stopMission}
        className="button is-danger mb-5 mr-3"
      >
        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
        Stop Mission
      </button>

      <button
        onClick={() => importPoints()}
        className="button is-info mb-5 mr-3"
      >
        <FontAwesomeIcon icon={faCog} className="is-small mr-1" />
        Import Points
      </button>


      {/* <div className="is-flex" style={{ flexWrap: "wrap" }}> */}
      {context.availableMissions?.length > 0 &&
        context.availableMissions.map((mission, i) => (
          //mission.robot === context.selectedRobot.name && mission.mapIndex === context.mapIndex &&
          <button key={i} className="button is-outlined is-link mr-2 mb-2" onClick={() => execMission(mission.name)}>
            {/* to fix */}
            {/* {(context.endOfMission && context.endOfMission.status === "executing" && context.endOfMission.name === mission.name) &&
              <FontAwesomeIcon icon={faCog} className="fas fa-pulse" />
            } */}
            {mission.name + " "}
          </button>
        ))}
      {/* </div> */}

      <ShowMessage />

      <div id="modal" className={showWarning ? "modal is-active" : "modal"}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">UV Light usage confirmation</p>
            <button className="delete" aria-label="close"></button>
          </header>

          <section className="modal-card-body">
            <div className="controls">
              {
                showCountdown ?
                  <div className="control">
                    <p>{countdown} seconds to start...</p>
                  </div>
                  :
                  <div className="control">
                    <p>You will turn on the UV Lights, are you sure?</p>
                    <p>You will have 10 seconds to leave the room and close the door.</p>
                  </div>
              }
            </div>
          </section>

          <footer className="modal-card-foot">
            {!showCountdown &&
              <>
                <button className="button is-success" onClick={startCountdown}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faCog} className="fas" />
                  </span>
                  <span>Confirm</span>
                </button>

                <button className="button" onClick={() => setShowWarning(false)}>
                  Cancel
                </button>
              </>
            }
          </footer>

        </div>
      </div>
    </div>
  )
}